import {GradientDefaultBox} from './gradient.default.box';
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";
import {GradientCasino777Box} from "./gradient.casino777.box";

export const GradientBox = styledByTheme(GradientDefaultBox).forCasino777(GradientCasino777Box).apply();